export default "__VITE_ASSET__50a0522c__"